//https://stackoverflow.com/questions/62995470/draw-route-between-two-points-in-vue

import { MapElementFactory } from "vue2-google-maps";

export default MapElementFactory({
  name: "directionsRenderer",

  ctr() {
    if (typeof google === 'undefined' || !google.maps || !google.maps.DirectionsRenderer) {
      return undefined;
    }
    return google.maps.DirectionsRenderer;
  },

  events: [],

  mappedProps: {},

  props: {
    origin: { type: Object },
    destination: { type: Object },
    travelMode: { type: String }
  },

  afterCreate(directionsRenderer) {
    let directionsService = new google.maps.DirectionsService();    
    if(this.origin && this.destination){
    	let request = {
    		origin: this.origin,
    		destination: this.destination,
    		travelMode: 'DRIVING'
  		};
    	directionsService.route(request,(response, status) => {
            if (status !== "OK") return;            	
            	directionsRenderer.setDirections(response);
          	}
        );
    }
    this.$watch(
      () => [this.origin, this.destination, this.travelMode],
      () => {
        let { origin, destination, travelMode } = this;
        if (!origin || !destination || !travelMode) return;              

        directionsService.route({
            origin,
            destination,
            travelMode
          },(response, status) => {
            if (status !== "OK") return;            	
            	directionsRenderer.setDirections(response);
          	}
        );
      }
    );
  }
});